import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './staticfiles/css/animate.css'
import './staticfiles/css/slick-carousel/slick.css'
import './staticfiles/css/slick-carousel/slick-theme.css'
import RegistrationApp from './App'
import * as serviceWorker from './serviceWorker'
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import 'react-datepicker/dist/react-datepicker.css'

library.add(fas, far, fab)

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<StrictMode>
  <RegistrationApp />
</StrictMode>)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
